import React from "react";
import { Slider } from "antd";
import { ReactComponent as PlayIcon } from "@/assets/icons/play.svg";
import { ReactComponent as SlowIcon } from "@/assets/icons/speed-slow.svg";
import { ReactComponent as FastIcon } from "@/assets/icons/speed-fast.svg";
import { ReactComponent as PauseIcon } from "@/assets/icons/pause.svg";
import "@/assets/audioCutSpeedVolume.less";

const AudioWorkCutRender = ({ playing, speedValue, speed, tooglePlay, handleSpeedChange }) => {
  return (
    <div className="work-speed">
      {playing ? (
        <PauseIcon style={{ width: 32, height: 32, marginBottom: 18, cursor: "pointer" }} onClick={tooglePlay} />
      ) : (
        <PlayIcon style={{ width: 32, height: 32, marginBottom: 18, cursor: "pointer" }} onClick={tooglePlay} />
      )}
      <div className={`speed-opr ${speed < 1 ? "left" : "right"}`}>
        <SlowIcon />
        <Slider value={speedValue} range min={0.5} max={3} step={0.01} marks={{ 1: "" }} onChange={handleSpeedChange} />
        <FastIcon />
        <span style={{ marginLeft: 6 }}>{speed.toFixed(2)}x</span>
      </div>
    </div>
  );
};

export default AudioWorkCutRender;
